"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAPIKeyDto = void 0;
class CreateAPIKeyDto {
    title;
    owner;
    isArchived;
    expireAt;
    permissions;
    limitReqsPerDay;
    hooks;
}
exports.CreateAPIKeyDto = CreateAPIKeyDto;
